<template>
  <div>
    <b-card title="Media" no-body>
    <b-card-header>
      <div class="d-flex">
        <div class="p-1">
          <h3>Media</h3>
        </div>
        <div class="ml-auto p-1">
          <b-button-group size="sm">
            <b-button
              variant="success"
              @click="switchView('list')"
              class="img-icon img-icon-bullet-list"
              v-bind:class="{ 'active' : getDefaultView !== 'card'  }">
            </b-button>
            <b-button
              variant="success"
              @click="switchView('card')"
              class="img-icon img-icon-drawer"
              v-bind:class="{ 'active' : getDefaultView === 'card' }">
            </b-button>
          </b-button-group>
        </div>
        <div class="p-1">
          <b-input-group size="sm">
            <b-form-input
              v-model="nameTagSearch"
              v-on:keyup.enter="searchClicked"
              type="search"
              id="mediaNameTagSearchInput"
              placeholder="Name Search"
            ></b-form-input>
          </b-input-group>
        </div>
        <div class="p-1">
          <b-button v-b-toggle.collapse-media-filters size="sm" v-b-popover.hover.left="'Advanced Search Filters'" variant="outline-primary">Advanced</b-button>
        </div>
        <div class="p-1">
          <b-button @click="searchClicked" size="sm" v-b-popover.hover.left="'Run Search Query'" variant="outline-primary">Search</b-button>
        </div>
      </div>
      <div>
        <b-collapse id="collapse-media-filters">
          <b-card class="mb-0">
            <b-form>
              <b-form-group
                id="advance-search-group"
                label="Advance Search"
                label-for="advanceSearch"
              >
                <b-form-input
                  v-model="searchTerm"
                  type="search"
                  id="advanceSearch"
                  placeholder="Advance Search"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-row class="col-12">
                  <b-form-group
                    label="Date Start"
                    label-for="filterDateStart"
                    class="col-4"
                  >
                  <b-form-input
                    v-model="filterDateStart"
                    type="date"
                    id="filterDateStart"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Date Finish"
                    label-for="filterDateFinish"
                    class="col-4"
                  >
                  <b-form-input
                    v-model="filterDateFinish"
                    type="date"
                    id="filterDateFinish"
                    ></b-form-input>
                  </b-form-group>
                </b-row>
              </b-form-group>
              <b-form-group>
                <b-button variant="outline-primary" @click="mediaAdvanceSearch">Search</b-button>
              </b-form-group>
            </b-form>
          </b-card>
        </b-collapse>
      </div>
    </b-card-header>

    <!-- Card Body -->
    <b-card-body >
      <div v-if="!this.session.loadedFirstPage" class="text-center p-3"><b-spinner size="sm"></b-spinner></div>
      <div v-else>
        <div v-if="mediaItems && mediaItems.length > 0">
          <template v-if="getDefaultView === 'card'">
            <div class="flex-container">
              <div v-for="mediaItem in mediaItems" :key="mediaItem.checksum">
                <entity-stub-card :entity="mediaItem" class="mx-2"></entity-stub-card>
              </div>
            </div>
          </template>

          <b-table
            id="job-search-table"
            ref="jobSearchTable"
            responsive
            :items="mediaItems"
            :fields="fields"
            v-else
          >
            <!-- Thumb Cell -->
            <template v-slot:cell(thumb)="entity" >
              <!-- this is the 4 thumbs alternative -->
              <div class="hw-fixed">
                <entity-media-wrapper :entity="entity.item"></entity-media-wrapper>
              </div>
            </template>

            <!-- Name Cell -->
            <template v-slot:cell(name)="entity" >
              <!-- <span> {{ row.item.name ? row.item.name : 'No Name' }} </span> -->
              <router-link :to="{ name: 'File Details', params: { size: entity.item.size, checksum: entity.item.checksum }}">{{ entity.item.name ? entity.item.name : 'No Name' }}</router-link>
            </template>

            <!-- Date Cell -->
            <template v-slot:cell(date)="entity" >
              <span> {{ $moment(entity.item.dateLastUpdated).calendar() }} </span>
            </template>

            <!-- Size Cell -->
            <template v-slot:cell(size)="entity" >
              <span> {{ entity.item.bytes | bytes }} </span>
            </template>

            <!-- Action Cell -->
            <template v-slot:cell(actions)="entity" >
              <manifest-cart-add-remove-item :entity="entity.item"></manifest-cart-add-remove-item>
            </template>

          </b-table>
        </div>
        <div v-else class="text-center p-3">
          No media associated with this project yet.
        </div>
      </div>
    </b-card-body>
      <b-card-footer>
        <b-form-invalid-feedback :state="!errorMessage" class="text-center">
            {{errorMessage}}
        </b-form-invalid-feedback>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>

import { EntityListSession } from '#/services/entities';
import EntityStubCard from '#/ui/Components/Entities/EntityStubCard.vue';
import EntityMediaWrapper from '#/ui/Components/Entities/EntityMediaWrapper.vue';
import ManifestCartAddRemoveItem from '#/ui/Components/Manifest/ManifestCartAddRemoveItem.vue';

export default {
  components: {
    EntityStubCard,
    EntityMediaWrapper,
    ManifestCartAddRemoveItem,
  },
  created() {
    return this.loadPage();
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
  computed: {
    errorMessage() {
      return this.session.errorMessage;
    },
    mediaItems() {
      console.log(this.session.entities);
      return this.session.entities;
    },
    loading() {
      return this.session.loading;
    },
    fullyLoaded() {
      return this.session.loadedLastPage;
    },
    getDefaultView() {
      return this.$store.getters['preferences/getToggleState'];
    },
  },
  data() {
    const cellClass = 'align-middle text-center';
    return {
      session: new EntityListSession(),
      nameTagSearch: null,
      // filterSearch: null,
      searchTerm: null,
      filterDateStart: null,
      filterDateFinish: null,
      fields: [
        { key: 'thumb', label: 'Media', class: cellClass, thStyle: { width: '300px'} },
        { key: 'name', label: 'Name', class: cellClass },
        { key: 'date', label: 'Date', class: cellClass },
        { key: 'size', label: 'Size', class: cellClass },
        { key: 'actions', label: 'Action', class: cellClass },
      ],
    };
  },
  methods: {
    switchView(viewType) {
      return this.$store.dispatch('preferences/setToggleState', viewType).then((response) => {
        console.log('Changed toggle state ', response);
      }).catch((error) => {
        console.log('Change toggle state error', error.message);
      });
    },
    scroll() {
      // TODO: is additional debouncing necessary?
      console.debug('MEDIA SCROLL EVENT');
      if (this.loading) {
        return;
      }
      const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        this.session.loadPage();
      }
    },
    searchClicked() {
      if (this.loading) {
        return;
      }
      console.log('media search clicked', this.nameTagSearch);
      this.session.resetPageData();
      this.loadPage();
    },
    async loadPage() {
      return this.session.loadPage();
    },
    mediaAdvanceSearch() {
      console.info(this.searchTerm, this.filterDateStart, this.filterDateFinish);
      this.session.filterSearch(this.searchTerm, this.filterDateStart, this.filterDateFinish);
      return this.session.loadPage();
    },
  },
};
</script>

<style scoped>

.flex-container {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

</style>
